import { useEffect, useState } from 'react';
import {
  propertyProfileService,
  type PropertyProfile,
} from '@/services/propertyProfileService';

export function usePropertyProfile(): PropertyProfile | null {
  const [profile, setProfile] = useState<PropertyProfile | null>(null);

  useEffect(() => {
    let active = true;
    propertyProfileService
      .get()
      .then((value) => {
        if (active) setProfile(value);
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, []);

  return profile;
}
